@let functions = expansion();
<div data-testid="analysis-extras">
  <app-coverage-tab-header
    titleKey="project.steps.rfi.invitationList.analysis.extrasTitle"
    subtitleKey="project.steps.rfi.invitationList.analysis.extrasIntro"
  />

  <div class="mb-[18px] grid grid-cols-2 gap-2.5 md:grid-cols-4">
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.card.availableToolFunctions"
      [value]="functions.availableCount"
      noteKey="project.steps.rfi.invitationList.analysis.card.availableToolFunctionsNote"
    />
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.card.requestedAvailable"
      [value]="functions.requestedAvailableCount"
      valueClass="text-green"
      noteKey="project.steps.rfi.invitationList.analysis.card.requestedAvailableNote"
    />
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.card.requestedMissing"
      [value]="functions.requestedMissingCount"
      valueClass="text-red"
      noteKey="project.steps.rfi.invitationList.analysis.card.requestedMissingNote"
    />
    <app-coverage-kpi-card
      labelKey="project.steps.rfi.invitationList.analysis.expansionPotential"
      [value]="(functions.percent | appNumber: '1.1-1') + ' %'"
      noteKey="project.steps.rfi.invitationList.analysis.card.expansionNote"
      [noteParams]="expansionNoteParams()"
    />
  </div>

  <div class="my-3">
    <app-coverage-section titleKey="project.steps.rfi.invitationList.analysis.scopeTitle">
      <div class="flex justify-between">
        <span>
          {{
            'project.steps.rfi.invitationList.analysis.scopeRequested'
              | transloco: {count: functions.requestedAvailableCount}
          }}
        </span>
        <span>
          {{
            'project.steps.rfi.invitationList.analysis.scopeAdditional'
              | transloco: {count: functions.additionalCount}
          }}
        </span>
      </div>
      <div class="bg-third-level my-3 flex h-4 overflow-hidden rounded">
        <div class="h-full bg-emerald-500" [style.width.%]="requestedShare()"></div>
        <div class="h-full bg-blue-400" [style.width.%]="functions.percent"></div>
      </div>
      <p class="text-muted-color text-sm">
        {{ 'project.steps.rfi.invitationList.analysis.scopeLegend' | transloco }}
      </p>
      <p class="mt-2">
        <b>{{ 'project.steps.rfi.invitationList.analysis.expansionPotential' | transloco }}:</b>
        {{
          'project.steps.rfi.invitationList.analysis.expansionFormula'
            | transloco
              : {additional: functions.additionalCount, available: functions.availableCount}
        }}
        = <b>{{ functions.percent | appNumber: '1.1-1' }} %</b>.
      </p>
    </app-coverage-section>
  </div>

  <div class="my-3">
    <app-coverage-section titleKey="project.steps.rfi.invitationList.analysis.statusTitle">
      <app-coverage-function-group
        titleKey="project.steps.rfi.invitationList.analysis.requestedAndAvailable"
        hintKey="project.steps.rfi.invitationList.analysis.requestedAndAvailableHint"
        [functionNames]="functions.coveredFunctionNames"
        tone="success"
        symbol="✓"
      />
      <app-coverage-function-group
        titleKey="project.steps.rfi.invitationList.analysis.requestedButMissing"
        hintKey="project.steps.rfi.invitationList.analysis.requestedButMissingHint"
        [functionNames]="functions.missingFunctionNames"
        tone="danger"
        symbol="✕"
      />
      <app-coverage-function-group
        titleKey="project.steps.rfi.invitationList.analysis.additionallyAvailable"
        hintKey="project.steps.rfi.invitationList.analysis.additionallyAvailableHint"
        [functionNames]="functions.additionalFunctionNames"
        tone="info"
        symbol="＋"
      />
    </app-coverage-section>
  </div>

  <app-coverage-note>
    <b>{{ 'project.steps.rfi.invitationList.analysis.countryNoteTitle' | transloco }}</b>
    {{ 'project.steps.rfi.invitationList.analysis.countryNote' | transloco }}
    <br /><br />
    <b>{{ 'project.steps.rfi.invitationList.analysis.informativeTitle' | transloco }}</b>
    {{ 'project.steps.rfi.invitationList.analysis.informativeNote' | transloco }}
  </app-coverage-note>
</div>
